import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type { ForumThread } from "@atrium/shared";
import { api, qs } from "../../lib/api";

export type ThreadSort = "activity" | "created";

export const threadsKey = (channelId: string) => ["threads", channelId] as const;
export const threadKey = (threadId: string) => ["thread", threadId] as const;
/** Messages inside a post live under their own key, next to the channel's. */
export const threadMessagesKey = (channelId: string, threadId: string) => ["messages", channelId, threadId];

export const useThreads = (channelId: string, sort: ThreadSort, tag: string | null) =>
  useInfiniteQuery({
    queryKey: [...threadsKey(channelId), sort, tag],
    queryFn: ({ pageParam }) =>
      api.get<{ items: ForumThread[]; nextCursor: string | null }>(
        `/api/channels/${channelId}/threads${qs({ sort, tag: tag ?? undefined, cursor: pageParam as string | undefined, limit: 25 })}`,
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (l) => l.nextCursor ?? undefined,
    staleTime: 30_000,
  });

export const useThread = (threadId: string | undefined) =>
  useQuery({
    queryKey: threadKey(threadId ?? ""),
    queryFn: () => api.get<ForumThread>(`/api/threads/${threadId}`),
    enabled: !!threadId,
    staleTime: 30_000,
  });
